import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import { getPriorAuthReferralSourceMasterResp } from "../../../actions/Master";
import { PriorAuthReferralSourceDispatchTypes } from "../../../models/DispatchTypes/Master";
import ReferralDetails from "../components/ReferralDetails";

const mapStateToProps = ({
  priorAuthReferralSourceState,
}: ApplicationState) => ({
  referralSourceFacilityMaster: priorAuthReferralSourceState,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    PriorAuthReferralSourceDispatchTypes
  >
) => {
  return {
    getPriorAuthReferralSourceFacilityMaster: () => {
      dispatch(getPriorAuthReferralSourceMasterResp());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ReferralDetails);
